module.exports = __webpack_public_path__ + "static/media/coins.1e8efa2a.svg";